/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/
export default {
  setCognitoUser(state, payload) {
    state.cognitoUser = payload;
    if (payload && Object.keys(payload).length > 0) {
      localStorage.setItem('cognitoUser', JSON.stringify(payload))
    } else {
      localStorage.removeItem('cognitoUser')
    }
  }
}
